import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import TOS from './components/routes/TOS';
import PrivacyPolicy from './components/routes/PrivacyPolicy';
import Help from './components/routes/Help';
import { View } from 'react-native';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/TOS" component={TOS} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/help" component={Help} />
        </Switch>
      </Router>
    );
  }
}

export default App;
